export default "__VITE_ASSET__FWM7RMS$__"